import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Autocomplete, Button, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getdistrictslist } from "../../action/user";


toast.configure();
const toasterOption = {
    position: "bottom center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
};

// Initial state with ALL fields
const initialFormValue = {
    // Personal Details
    full_name: "",
    email: "",
    phone_number: "",
    alt_phone_number: "",
    sex: "",

    // Location Details
    address: "",
    city: "",
    state: "",
    pincode: "",

    // Professional Details
    id_proof_type: "",
    id_proof_number: "",
    id_proof_file: "",

    // Account Info
    password: "",
    user_type: "agent",
};


export default function AgentRegistrationStepper() {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState(initialFormValue);
    const [districts, setDistricts] = useState([]);

    const [validateError, setValidateError] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const d = await getdistrictslist();
            const disOpts = d.userValue.map(d => ({ title: d.city, value: d._id }));
            setDistricts(disOpts);
        };
        fetchData();
    }, []);

    // Required fields
    const requiredFields = {
        0: ["full_name", "email", "phone_number", "sex", "address", "city", "state", "pincode", "password"],
    };

    const validateStep = () => {
        const errors = {};
        (requiredFields[activeStep] || []).forEach(field => {
            const val = formData[field];
            if (!val || val.toString().trim() === "") {
                errors[field] = "This field is required";
            }
        });
        setValidateError(errors);
        return Object.keys(errors).length === 0;
    };

    const handleNext = () => {
        // if (validateStep()) 
        setActiveStep(prev => prev + 1);
    };

    const handleBack = () => setActiveStep(prev => prev - 1);

    const handleSubmit = async () => {
        // if (!validateStep()) return;
        navigate("/agent/profile");
        // const payload = { ...formData };
        // let { error } = await addregister(payload);
        // if (isEmpty(error)) {
        //     toast.success("Agent Registered successfully", toasterOption);
        //     history("/");
        //     swal("Agent Registered successfully");
        // } else {
        //     setValidateError(error);
        //     swal("Please fill in all required fields");
        // }
    };

    const handleLogin = async () => {
        navigate("/agent/login");
    }

    const sexch = [
        { title: "Male", value: "Male" },
        { title: "Female", value: "Female" },
    ];

    const idProffTypes = [
        "Aadhaar Card",
        "PAN Card",
        "Voter ID",
        "Driving License",
        "Passport"
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const fileInputRef = useRef(null);

    const handleFile = (event) => {
        const file = event.target.files[0];
        if (file) {
            const maxSize = 5 * 1024 * 1024; // 5MB
            if (file.size > maxSize) {
                alert("File size must be less than 5MB!");
                event.target.value = "";
                return;
            }

            const previewURL = URL.createObjectURL(file);

            setFormData(prev => ({
                ...prev,
                id_proof_file: file,
                id_proof_preview: previewURL, // ✅ store preview
            }));
        }
    };

    const handleRemoveFile = () => {
        setFormData(prev => ({ ...prev, id_proof_file: null, id_proof_preview: null }));
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const handlePwdChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const [showPassword, setShowPassword] = React.useState(false);
    const toggleShowPassword = () => setShowPassword((prev) => !prev);

    return (
        <div style={{ marginTop: '30px' }}>
            <h2 class="font-great-vibes" style={{ margin: '0px 20px', color: '#B21919', }}>
                Agent Registration
            </h2>
            <div style={{ maxWidth: 800, margin: "0 auto", padding: 20 }}>
                {/* Full Name */}
                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Full Name"
                        name="full_name"
                        value={formData.full_name}
                        onChange={handleChange}
                        error={!!validateError.full_name}
                        helperText={validateError.full_name}
                        variant="outlined"
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        sx={{
                            '& .MuiInputBase-input': {
                                fontSize: '16px',
                            }
                        }}
                        required
                    />
                </div>

                {/* Email */}
                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        error={!!validateError.email}
                        helperText={validateError.email}
                        variant="outlined"
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        sx={{
                            '& .MuiInputBase-input': {
                                fontSize: '16px',
                            }
                        }}
                        required
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Mobile Number"
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleChange}
                        error={!!validateError.phone_number}
                        helperText={validateError.phone_number}
                        variant="outlined"
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        sx={{
                            '& .MuiInputBase-input': {
                                fontSize: '16px',
                            }
                        }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Alternative Mobile Number"
                        name="alt_phone_number"
                        value={formData.alt_phone_number}
                        onChange={handleChange}
                        error={!!validateError.alt_phone_number}
                        helperText={validateError.alt_phone_number}
                        variant="outlined"
                        FormHelperTextProps={{
                            style: { fontSize: "14px", color: "red" },
                        }}
                        sx={{
                            '& .MuiInputBase-input': {
                                fontSize: '16px',
                            }
                        }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <Autocomplete
                        options={sexch || []}
                        getOptionLabel={(o) => (o?.title ? o.title : "")}
                        getOptionSelected={(option, value) => option?.value === value?.value}
                        value={formData.sex || null}
                        onChange={(e, v) => setFormData((prev) => ({ ...prev, sex: v }))}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                label="Gender"
                                error={!!validateError.sex}
                                helperText={validateError.sex}
                                variant="outlined"
                                FormHelperTextProps={{
                                    style: { fontSize: "14px", color: "red" },
                                }}
                                InputLabelProps={{
                                    sx: {
                                        ".MuiInputLabel-asterisk": {
                                            color: "red",
                                            fontSize: "1.2em",
                                        }
                                    }
                                }}
                                required
                            />
                        )}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        error={!!validateError.address}
                        helperText={validateError.address}
                        variant="outlined"
                        FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
                        sx={{ '& .MuiInputBase-input': { fontSize: '16px' } }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <Autocomplete
                        options={districts || []}
                        getOptionLabel={(o) => (o?.title ? o.title : "")}
                        getOptionSelected={(option, value) => option?.value === value?.value}
                        value={formData.city || null}
                        onChange={(e, v) => setFormData((prev) => ({ ...prev, city: v }))}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                label="City"
                                error={!!validateError.city}
                                helperText={validateError.city}
                                variant="outlined"
                                FormHelperTextProps={{
                                    style: { fontSize: "14px", color: "red" },
                                }}
                                InputLabelProps={{
                                    sx: {
                                        ".MuiInputLabel-asterisk": {
                                            color: "red",
                                            fontSize: "1.2em",
                                        }
                                    }
                                }}
                                required
                            />
                        )}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="State"
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        error={!!validateError.state}
                        helperText={validateError.state}
                        variant="outlined"
                        FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
                        sx={{ '& .MuiInputBase-input': { fontSize: '16px' } }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Pincode"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                        error={!!validateError.pincode}
                        helperText={validateError.pincode}
                        variant="outlined"
                        FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
                        sx={{ '& .MuiInputBase-input': { fontSize: '16px' } }}
                        InputLabelProps={{
                            sx: {
                                ".MuiInputLabel-asterisk": {
                                    color: "red",
                                    fontSize: "1.2em",
                                }
                            }
                        }}
                        required
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <Autocomplete
                        options={idProffTypes}
                        value={formData.id_proof_type || ""}
                        onChange={(event, value) =>
                            setFormData((prev) => ({ ...prev, id_proof_type: value }))
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="ID Proof Type"
                                fullWidth
                                error={!!validateError.id_proof_type}
                                helperText={validateError.id_proof_type}
                                variant="outlined"
                                FormHelperTextProps={{
                                    style: { fontSize: "14px", color: "red" }
                                }}
                            />
                        )}
                        sx={{ '& .MuiInputBase-input': { fontSize: '16px' } }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="ID Proof Number"
                        name="id_proof_number"
                        value={formData.id_proof_number}
                        onChange={handleChange}
                        error={!!validateError.id_proof_number}
                        helperText={validateError.id_proof_number}
                        variant="outlined"
                        FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
                        sx={{ '& .MuiInputBase-input': { fontSize: '16px' } }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        type={showPassword ? "text" : "password"}
                        label="Password"
                        name="password"
                        value={formData.password}
                        onChange={handlePwdChange}
                        error={!!validateError.password}
                        helperText={validateError.password}
                        variant="outlined"
                        FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
                        sx={{ '& .MuiInputBase-input': { fontSize: '16px' } }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={toggleShowPassword} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                </div>

                <div style={{ margin: "1em 0" }}>
                    {formData.id_proof_preview && (
                        <div style={{ marginBottom: "8px" }}>
                            <img
                                src={formData.id_proof_preview}
                                alt="ID Proof"
                                style={{
                                    maxWidth: "120px",
                                    borderRadius: "8px",
                                    marginBottom: "8px"
                                }}
                            />
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={handleRemoveFile}
                                style={{ marginLeft: "8px" }}
                            >
                                Remove
                            </Button>
                        </div>
                    )}

                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        component="label"
                        style={{
                            padding: "14px",
                            fontSize: "1rem",
                            fontWeight: "bold",
                            borderRadius: "6px",
                            background: "#B21919",
                            color: "#FFFFFF"
                        }}
                    >
                        {formData.id_proof_file ? "Change ID Proof" : "Upload ID Proof"}
                        <input type="file" accept="image/*,.pdf" hidden onChange={handleFile} ref={fileInputRef} />
                    </Button>
                </div>

                <div style={{ margin: "1em 0", display: "flex", justifyContent: "space-between" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleLogin}
                        style={{ padding: "14px 28px", fontSize: "1.2rem", fontWeight: "bold", borderRadius: "6px", background: "#B21919", color: "#FFFFFF" }}
                    >
                        Already Registered?
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        style={{ padding: "14px 28px", fontSize: "1.2rem", fontWeight: "bold", borderRadius: "6px", background: "#B21919", color: "#FFFFFF" }}
                    >
                        Submit
                    </Button>
                </div>
            </div>

        </div>
    );
}

